module.exports = __webpack_public_path__ + "img/Aura_darkness.51b72f42.png";